import { FormInstance } from 'antd';

import { CardExplorer, ExplorerInputDescription } from '@page/explorer/explorer.style';
import { Select } from '@style/global-style.app';

import { Input } from '@atom/form/input/input';
import { Text, Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { Form } from '@form/common.style';
import { isString } from '@util/data/is-exist';

interface ExplorerHeadersProps {
  form: FormInstance;
  fields: Record<string, any>[];
}

export const ExplorerHeaders = ({ form, fields }: ExplorerHeadersProps) => (
  <CardExplorer>
    <Title color={ColorEnum.Black100} level={5} mb={8} weight={400}>
      Headers
    </Title>
    <Form form={form} layout='vertical'>
      {fields.map((field) => {
        const { label = field.key, placeholder = field.key, description, list, type } = field.description ?? {};
        return (
          <Form.Item
            key={field.key}
            name={['headers', field.key]}
            label={
              <>
                <Text color={ColorEnum.Black100} level='s'>
                  {label}
                </Text>
                {isString(description) && <ExplorerInputDescription>{description}</ExplorerInputDescription>}
              </>
            }
          >
            {Array.isArray(list) ? (
              <Select
                mode={type === 'multipleList' ? 'multiple' : undefined}
                options={list}
                placeholder={placeholder}
              />
            ) : (
              <Input placeholder={placeholder} />
            )}
          </Form.Item>
        );
      })}
    </Form>
  </CardExplorer>
);
